'use client';
import LoginIcon from '@/icons/LoginIcon';
import { BookmarkIcon } from '@/icons/BookmarkIcon';
import { useAuth } from '@/providers/AuthProvider';
import { FollowIcon } from '@/icons/FollowIcon';
import safeLocalStorage from '@/utils/safeLocalStorage';
import { ArrowLeftIcon } from '@/icons/ArrowLeftIcon';
import { useEffect, useState } from 'react';
import { cn } from '@pulsex/utils';

export default function LoginButton() {
    const { authUser, login, logout } = useAuth();
    const [isAlertActive, setIsAlertActive] = useState(true);

    const handleLogin = () => {
        if (safeLocalStorage.isLocalStorageAvailable) {
            login();
        } else {
            alert('Cookies must be enabled to login.');
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsAlertActive(false);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="container">
            <div className="flex items-center justify-end border-b py-2">
                {authUser ? (
                    <div className="flex items-center text-black relative group ml-2">
                        <button
                            onClick={logout}
                            className="absolute bg-white border rounded-md inset-0 hidden group-hover:block"
                        >
                            Log out
                        </button>
                        {authUser?.name ? (
                            <div className="flex flex-col">
                                <span className="text-sm leading-3 text-left">Welcome</span>
                                <span className="text-base leading-4">{authUser?.name}</span>
                            </div>
                        ) : (
                            ''
                        )}
                        {authUser?.photoURL ? (
                            <img
                                src={authUser?.photoURL}
                                alt="Profile"
                                className="w-8 h-8 rounded-full mr-1.5"
                            />
                        ) : (
                            ''
                        )}
                    </div>
                ) : (
                    // <button onClick={handleLogin} className="border rounded-full p-1 group">
                    //     <LoginIcon className="fill-black group-hover:fill-masterRed" size={22} />
                    // </button>
                    <button
                        onClick={handleLogin}
                        className="bg-[linear-gradient(to_top,_#c80f1d,_#e55e5b)] text-white p-1 px-3 rounded-full shadow-md border-2 border-white group"
                    >
                        <span>تسجيل الدخول</span>
                    </button>
                )}

                <div className="relative flex">
                    {authUser ? (
                        <a
                            href="/bookmark"
                            className={cn(
                                'border rounded-full p-1 group relative',
                                isAlertActive && 'bg-masterRed border-white shadow-md'
                            )}
                        >
                            <BookmarkIcon
                                className={cn(
                                    'stroke-black group-hover:stroke-masterRed',
                                    isAlertActive && 'stroke-white'
                                )}
                                size={22}
                            />
                            <div className="group-hover:visible group-hover:opacity-100 opacity-0 transition-opacity duration-300 invisible absolute z-10 w-[190px] rounded-sm text-center top-full translate-y-3 left-1/2 -translate-x-1/2 bg-masterRed text-white p-2 after:content-[''] after:absolute after:bottom-full after:left-1/2 after:-translate-x-1/2 after:border-8 after:border-transparent after:border-b-masterRed">
                                المكتبة الرقمية لـ {authUser?.name.split(' ')[0]}
                            </div>
                        </a>
                    ) : (
                        <div
                            className="border rounded-full p-1 mr-2 opacity-85 pointer-events-none"
                            title="Login to access bookmarks"
                        >
                            <BookmarkIcon className="stroke-gray-400" size={22} />
                        </div>
                    )}

                    {authUser ? (
                        <a
                            href="/following"
                            className={cn(
                                'border rounded-full p-1 mr-2 group transition-all duration-300 relative',
                                isAlertActive && 'bg-masterRed border-white shadow-md'
                            )}
                        >
                            <FollowIcon
                                className={cn(
                                    'stroke-black group-hover:stroke-masterRed transition-all duration-300',
                                    isAlertActive && 'stroke-white'
                                )}
                                size={22}
                            />
                            <div className="group-hover:visible group-hover:opacity-100 opacity-0 transition-opacity duration-300 invisible absolute z-10 w-[250px] rounded-sm text-center top-full translate-y-3 left-1/2 -translate-x-1/2 bg-masterRed text-white p-2 after:content-[''] after:absolute after:bottom-full after:left-1/2 after:-translate-x-1/2 after:border-8 after:border-transparent after:border-b-masterRed">
                                قائمة الكتاب الذين يتابعهم {authUser?.name.split(' ')[0]}
                            </div>
                        </a>
                    ) : (
                        <div
                            className="border rounded-full p-1 mr-2 opacity-85 pointer-events-none"
                            title="Login to access following"
                        >
                            <FollowIcon className="stroke-gray-400" size={22} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
